import { NotificationRegistry } from '@neos/core'

/**
 * Represents Notifications.
 */
export default class Notifications extends NotificationRegistry {
}